import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FadeIn } from '../components/ui/FadeIn';
import { AppStoreButtons } from '../components/AppStoreButtons';
import { AudienceShowcase } from '../components/AudienceShowcase';
import { SiteFooter } from '../components/ui/SiteFooter';
import { appTourSteps, practitionerApplicationUrl } from '../data/appTour';
export function AppLaunchPage() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-467" data-mp="30wmz5y9rnpba">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-468" data-mp="35v7zdxp0q8zq">
        <a href="/" aria-label="Fem Entity home" data-id="element-469" data-mp="3fljhqp9g8kq5">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-470" data-mp="2i5dnbiciwogj" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-471" data-mp="3pp3e4bb0rd3b">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-472" data-mp="3pqxpoz0ehsuq">
            Home
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-473" data-mp="3kscq91sz3d7c">
            Practitioners
          </a>
          <a href="/get-the-app" className="text-purple-700 font-semibold" data-id="element-474" data-mp="3bx6pwich1nc7">
            Download the App
          </a>
        </div>
      </nav>

      <main data-id="element-475" data-mp="31zilf0p2d1gu">
        {/* Launch hero */}
        <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-14 md:pb-20" data-id="element-476" data-mp="31yqxmc1pk814">
          <div className="max-w-4xl" data-id="element-477" data-mp="2x1gy23klufzk">
            <FadeIn data-id="element-478" data-mp="2x2id0j4qrmmk">
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-6" data-id="element-479" data-mp="2syu6m3ruix2w">
                Now available on iOS and Android
              </p>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-charcoal leading-[1.05] tracking-tight" data-id="element-480" data-mp="v6yiv5eo3aru">
                Your whole wellness team,{' '}
                <span className="italic text-purple-800" data-id="element-481" data-mp="2kp53oqle0g5x">in your pocket</span>
              </h1>
              <p className="mt-7 max-w-2xl text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-482" data-mp="2phy8tfkrpqij">
                Get matched with verified practitioners, book care that fits
                your life, and track how you're really doing — all in the Fem
                Entity app.
              </p>
            </FadeIn>

            <FadeIn delay={150} data-id="element-483" data-mp="33hh3p6okj5cw">
              <AppStoreButtons className="mt-10" data-id="element-484" data-mp="38fiphzddpis2" />
              <p className="mt-5 text-sm text-charcoal/50" data-id="element-485" data-mp="38f8yq9kif7lb">
                Free to download. Available across Canada, excluding Quebec.
              </p>
            </FadeIn>
          </div>
        </section>

        {/* Two sides of the app */}
        <section aria-labelledby="audiences-heading" className="bg-purple-50 border-y border-purple-100 py-16 md:py-24" data-id="element-486" data-mp="1j1449p1kke1b">
          <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-487" data-mp="1o1if1euk2231">
            <FadeIn className="max-w-2xl mb-12" data-id="element-488" data-mp="1fidnvt6ozrg1">
              <h2 id="audiences-heading" className="font-serif text-3xl md:text-5xl text-charcoal leading-tight" data-id="element-489" data-mp="1fh3pf2vxgh8v">
                One app, both sides of care
              </h2>
              <p className="mt-5 text-lg text-charcoal/70 font-light leading-relaxed" data-id="element-490" data-mp="1ki02o7265fqy">
                Built for the women seeking support, and for the practitioners
                who provide it.
              </p>
            </FadeIn>

            <AudienceShowcase data-id="element-491" data-mp="ru3zcji3gpl7" />
          </div>
        </section>

        {/* The journey, in order */}
        <section aria-labelledby="journey-heading" className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28" data-id="element-492" data-mp="16ja4sp7izc1j">
          <FadeIn data-id="element-493" data-mp="11pfe31ti5wsy">
            <h2 id="journey-heading" className="font-serif text-3xl md:text-5xl text-charcoal leading-tight max-w-2xl" data-id="element-494" data-mp="e1xqlih9tkvs">
              How it works, step by step
            </h2>
          </FadeIn>

          <ol className="mt-14 max-w-3xl border-l border-purple-200" data-id="element-495" data-mp="38hwpxvnjl3dc">
            {appTourSteps.map((step, index) => <li key={step.title} className="relative pl-8 md:pl-12 pb-12 last:pb-0" data-id="element-496" data-mp="3dggc9x61sh68" data-mpi={index}>
                <span aria-hidden="true" className="absolute -left-[13px] top-1 flex h-6 w-6 items-center justify-center rounded-full bg-purple-700 text-[11px] font-semibold text-white" data-id="element-497" data-mp="3hgqm5kwynrqd">
                  {index + 1}
                </span>
                <h3 className="font-serif text-xl md:text-2xl text-charcoal leading-snug" data-id="element-498" data-mp="3w54wegwpiigy">
                  {step.title}
                </h3>
                <p className="mt-3 text-base text-charcoal/70 leading-[1.8]" data-id="element-499" data-mp="4yakfo0grtl3">
                  {step.description}
                </p>
              </li>)}
          </ol>
        </section>

        {/* Practitioner path */}
        <section className="bg-purple-100/70 border-y border-purple-200" data-id="element-500" data-mp="2ask0xjtk0xbl">
          <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-501" data-mp="239kh5d26l3rp">
            <div className="max-w-2xl" data-id="element-502" data-mp="1yhsw1i1snq8y">
              <h2 className="font-serif text-2xl md:text-3xl text-charcoal leading-snug" data-id="element-503" data-mp="1yh12ecrrc2lb">
                Are you a practitioner?
              </h2>
              <p className="mt-3 text-base text-charcoal/70 leading-relaxed" data-id="element-504" data-mp="1pj7817djzj0s">
                Apply to join our vetted network and manage your schedule,
                services, and payments from the same app.
              </p>
            </div>
            <a href={practitionerApplicationUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-charcoal/25 px-7 py-4 text-base font-semibold text-charcoal transition-colors duration-200 ease-out hover:border-purple-700 hover:text-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-100" data-id="element-505" data-mp="2h78ywc0ybusj">
              Apply to the network
              <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-506" data-mp="138pf9mrqmv71" />
            </a>
          </div>
        </section>

        {/* Final download */}
        <section className="bg-charcoal py-20 md:py-28 text-center" data-id="element-507" data-mp="pcbtw2k329na">
          <div className="max-w-3xl mx-auto px-6" data-id="element-508" data-mp="t9zunm8giwn3">
            <FadeIn data-id="element-509" data-mp="fkftgkuiy7fw">
              <h2 className="font-serif text-3xl md:text-5xl text-ivory leading-tight" data-id="element-510" data-mp="fj4sstwdlft0">
                Start where you are
              </h2>
              <p className="mt-6 text-lg text-ivory/70 font-light leading-relaxed" data-id="element-511" data-mp="kczaxswc1mpz">
                Download the app and take the matching quiz — your first
                practitioner match takes about two minutes.
              </p>
            </FadeIn>
            <AppStoreButtons tone="dark" className="mt-10 justify-center items-center" data-id="element-512" data-mp="3srr1yy8wi95s" />
          </div>
        </section>
      </main>

      <SiteFooter currentPath="/get-the-app" data-id="element-513" data-mp="3e3qzuzwxwu9v" />
    </div>;
}